import { BodyDefaultTypography } from '@npco/zeller-design-system'
import styled from 'styled-components'

import { BREAKPOINT } from 'styles/breakpoints'
import {
  CancelButton,
  ConfirmButton,
} from 'components/Modal/ModalElements/ModalElements'

export const StyledRedirectButton = styled.button`
  ${BodyDefaultTypography};
  color: ${({ theme }) => theme.colors.BLUE_1000};
  outline: none;
  padding: 0;
  border: 0;
  margin: 0;
  background-color: transparent;
  cursor: pointer;

  &:focus,
  &:hover {
    text-decoration: underline;
  }
`

export const StyledCancelButton = styled(CancelButton)`
  @media screen and (max-width: ${BREAKPOINT.XS - 1}px) {
    margin-bottom: 1rem;
    margin-right: 0;
  }
`

export const StyledConfirmButton = styled(ConfirmButton)`
  @media screen and (max-width: ${BREAKPOINT.XS - 1}px) {
    margin-left: 0;
  }
`
